<template>
  <div v-if="diaryEntry" class="fill-width">
    <debug :object="diaryEntry" />

    <div class="section-info">
      <img class="diary-logo" src="static/diary-logo.png" alt="Diary Logo" />
      <div class="diary">
        <h2>{{ $t('Review your entry') }}</h2>
      </div>
    </div>

    <diary-summary :diaryEntry="diaryEntry" :projectCity="currentProject.address.city" />

    <div class="section">
      <router-link
        class="negative-button icon-button"
        :title="$t('Go Back')"
        :to="{ name: 'DiaryEditEntries', params: { _id: $route.params._id, date: currentDate } }"
      >
        <b-icon icon="arrow-left-short" />
      </router-link>

      <button class="icon-button positive-button" @click="signOff">
        <b-icon icon="arrow-right-short" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import DiarySummary from '@/components/diary/DiarySummary';

export default {
  name: 'DiaryConfirm',

  components: {
    DiarySummary,
  },

  metaInfo() {
    return {
      title: `${this.$t('Diary')} ${this.$t('Review your entry')} ${this.currentDate}`,
    };
  },

  data() {
    return {
      diaryEntry: {},
    };
  },

  computed: {
    ...mapGetters(['currentProject']),

    currentDate() {
      return this.$route.params.date;
    },
  },

  methods: {
    ...mapActions(['getDiaryEntryForDate', 'loadProject', 'saveDiaryEntryProperties', 'getPreviousDiaryEntryForDate']),

    updateProperty(property, newValue) {
      if (this.diaryEntry[property] !== newValue) {
        this.saveDiaryEntryProperties({
          diaryEntry: this.diaryEntry,
          [property]: newValue,
        });
      }
    },

    signOff() {
      this.updateProperty('signedOff', true);
      this.$router.push({ name: 'GoodJob' });
    },
  },

  watch: {
    $route: {
      immediate: true,
      async handler(next) {
        await this.loadProject(next.params._id);
        this.diaryEntry = await this.getDiaryEntryForDate(this.currentDate);
      },
    },
  },
};
</script>

<style scoped>
.section {
  border-top: 1px solid #253747;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
}

.section > * {
  margin: 12px;
}

.section-info {
  border-top: 1px solid #253747;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 18px;
}

.diary-logo {
  max-width: 100px;
  margin-right: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/DiaryConfirm.vue